// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1Rkfk","header":"style_header__1pDW9","text":"style_text__3cZBc","saveBtn":"style_saveBtn__1I4eN"};